<template>
    <el-form :model="as3form" ref="formRef" label-position="top" :rules="rules">
        <Panel title="连接池配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="服务器IP地址" prop='host'>
                        <el-input v-model="value.host"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="监听端口" prop='port'>
                        <el-input v-model="value.port"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="用户名" prop='username'>
                        <el-input v-model="value.username"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="密码" prop='password'>
                        <el-input v-model="value.password"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级选项" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="连接模式" prop='passive'>
                        <el-radio v-model="value.passive" label="true">是</el-radio>
                        <el-radio v-model="value.passive" label="false">否</el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="是否是隐式加密" prop='implicit'>
                        <el-radio v-model="value.implicit" label="true">是</el-radio>
                        <el-radio v-model="value.implicit" label="false">否</el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器地址" prop='proxyhost'>
                        <el-input v-model="value.proxyhost"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器端口号" prop='proxyport'>
                        <el-input v-model="value.proxyport"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器用户名" prop='proxyusername'>
                        <el-input v-model="value.proxyusername"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器密码" prop='proxypassword'>
                        <el-input v-model="value.proxypassword"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="连接超时时间" prop='timeout'>
                        <el-input v-model="value.timeout"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="等待超时时间" prop='autonoop'>
                        <el-input v-model="value.autonoop"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="加密数据通道" prop='endata'>
                        <el-radio v-model="value.endata" label="true">是</el-radio>
                        <el-radio v-model="value.endata" label="false">否</el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="是否使用FTP" prop='useftp'>
                        <el-radio v-model="value.useftp" label="true">是</el-radio>
                        <el-radio v-model="value.useftp" label="false">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>
<script>
export default {
    // host: "",
    // port: "",
    // username: "",
    // password: "",
    // passive: "true",
    // implicit: "true",
    // proxyhost: "",
    // proxyport: "",
    // proxyusername: "",
    // proxypassword: "",
    // timeout: "120",
    // autonoop: "0",
    // endata: "false",
    // useftp: "false"
    props: {
        value: Object,
        init: Boolean
    },
    data() {
        return {
            rules: {
                host: [{required: true, trigger: "blur", message: "这是必填字段"}],
                port: [{required: true, trigger: "blur", message: "这是必填字段"}]
            }
        };
    },
    mounted() {
        if(this.init) {
            this.$set(this.value, 'passive', 'true');
            this.$set(this.value, 'implicit', 'true');
            this.$set(this.value, 'autonoop', '0');
            this.$set(this.value, 'timeout', '120');
            this.$set(this.value, 'endata', 'false');
            this.$set(this.value, 'useftp', 'false');
        }
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }
};
</script>

